import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import ErrorIcon from './ErrorIcon';
import * as Sentry from '@sentry/react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Capture error in Sentry
    Sentry.captureException(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Capture additional error info
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: 1,
            textAlign: 'center',
            '& svg': {
              width: '100%',
              maxWidth: 400,
              color: (theme) => theme.palette.primary.main,
            },
          }}
        >
          <ErrorIcon />
          <Typography variant="h2" sx={{ fontSize: 30, mt: 2 }}>
            Ah! Something went wrong.
          </Typography>
          <Typography sx={{ fontSize: 18, mt: 1 }}>
            Brace yourself till we get the error fixed.
          </Typography>
          <Typography sx={{ fontSize: 18 }}>
            You may also refresh the page or try again later.
          </Typography>
          <Button
            color="primary"
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => this.setState({ hasError: false })}
          >
            Try again
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default AppErrorBoundary;
